
document.addEventListener("DOMContentLoaded", function () {
    const spans = document.querySelectorAll(".way_section .content h3 span");

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("active");
                } else {
                    entry.target.classList.remove("active");
                }
            });
        },
        {
            threshold: 1,
        }
    );

    spans.forEach((span) => observer.observe(span));
});

$(document).ready(function() {
  // On page load, find the active color and set the selected color name
  var activeSwatch = $('.variant_colors a.active');
  if (activeSwatch.length > 0) {
    var activeColorName = activeSwatch.data('color-name');
    $('#selected-color-name').text(activeColorName); // Set the default color name on page load
  }

  // Handle swatch click event
  $(document).on('click', '.variant_colors a', function(event) {
    // Get the color name from the clicked swatch
    var colorName = $(this).data('color-name');

    // Update the selected color span with the color name
    $('#selected-color-name').text(colorName);

    // Remove 'active' class from all swatches
    $('.variant_colors a').removeClass('active');

    // Add 'active' class to the clicked swatch
    $(this).addClass('active');

    // Allow the default anchor behavior (so the page navigates to the clicked product)
  });

});


jQuery(document).ready(function ($) {
    $('.everything-slider').slick({
        centerPadding: '0',
        slidesToShow: 3,
        arrows: true,
        dots: false,
        autoplay: true,
        infinite:true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });
});

jQuery(document).ready(function ($) {
    $('.reviews-slider').slick({
        centerPadding: '30px',
        slidesToShow: 3,
        arrows: true,
        dots: false,
        autoplay: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1
                }
            } 
        ]
    });
});

jQuery(document).ready(function ($) {
    $('.my-slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 4000,
        cssEase: 'linear',
        infinite: true,
        arrows: false,
        dots: false,
        pauseOnHover: false,
        pauseOnFocus: false,

        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    speed: 4000,
                    autoplaySpeed: 0,
                    cssEase: 'linear'
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    speed: 4000,
                    autoplaySpeed: 0,
                    cssEase: 'linear'
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    speed: 4000,
                    autoplaySpeed: 0,
                    cssEase: 'linear'
                }
            }
        ]
    });
});


// Time-line section js Start

const wrap = document.querySelector(".how-wrap");
        const steps = document.querySelectorAll(".how-step");

        let activeIndex = 0;

        /* ---------- FORCE FIRST ACTIVE ---------- */
        function forceFirst() {
            steps.forEach(s => s.classList.remove("active"));
            steps[0].classList.add("active");
            wrap.style.setProperty("--fill", "0%");
        }
        forceFirst();

        /* ---------- SCROLL HANDLER ---------- */
        function updateOnScroll() {
            const wrapTop = wrap.getBoundingClientRect().top + window.scrollY;
            const wrapBottom = wrapTop + wrap.offsetHeight;

            const viewTop = window.scrollY;
            const viewBottom = viewTop + window.innerHeight;

            // ⛔ Before reaching section → always first active
            if (viewBottom < wrapTop) {
                forceFirst();
                return;
            }

            // ⛔ After leaving section → always last active
            if (viewTop > wrapBottom) {
                activeIndex = steps.length - 1;
                steps.forEach(s => s.classList.remove("active"));
                steps[activeIndex].classList.add("active");
                wrap.style.setProperty("--fill", "100%");
                return;
            }

            // Normal progress calculation
            const visible = (viewBottom - wrapTop) / (wrap.offsetHeight + window.innerHeight);
            const clamped = Math.min(Math.max(visible, 0), 1);
            const newIndex = Math.round(clamped * (steps.length - 1));

            if (newIndex !== activeIndex) {
                activeIndex = newIndex;
                steps.forEach(s => s.classList.remove("active"));
                steps[activeIndex].classList.add("active");
                wrap.style.setProperty("--fill", (activeIndex / (steps.length - 1)) * 100 + "%");
            }
        }

        window.addEventListener("scroll", updateOnScroll);
        updateOnScroll();


// Time-line section js End

    
// Faq JS Start
 jQuery(".accordion-heading").click(function(e){
      if(!$(this).closest(".accordion-box").hasClass("open"))
    {
      $(".accordion-box .accordion_body").slideUp();
      $(".accordion-box").removeClass("open");
      $(this).closest(".accordion-box").find(".accordion_body").slideToggle();
      $(this).closest(".accordion-box").toggleClass("open");
    }
    else
    {
      $(".accordion-box .accordion_body").slideUp();
      $(".accordion-box").removeClass("open");
    }
  });

// Faq Js End

// Varient Description JS Start

// Varient Description JS End